export const readFile = (file) =>
  new Promise((resolve) => {
    if (!file) return { file, dataURL: null };

    const reader = new FileReader();

    // Read the image via FileReader API and save image result in state.
    reader.onload = (e) => {
      // Add the file name to the data URL
      const dataURL = e.target.result.replace(';base64', `;name=${file.name};base64`);
      resolve({ file, dataURL });
    };

    reader.readAsDataURL(file);
  });
